import type { JSX } from 'react'

import { COLOR } from 'vars/color'
import { VoiceSearchLoaderProSC } from './VoiceSearchLoader.styled'

export const VoiceSearchLoader = (): JSX.Element => {
  return (
    <VoiceSearchLoaderProSC>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='189'
        height='189'
        viewBox='0 0 189 189'
        fill='none'
      >
        <path
          d='M144.527 24.8246C152.3 30.4104 158.773 39.0913 162.98 51.928C171.886 89.5135 159.088 134.202 125.061 153.392C107.886 163.077 84.5508 168.252 64.0535 165.819C43.589 163.389 26.3674 153.472 20.4261 133.351C8.17951 91.8746 23.8393 52.5672 58.0164 33.2933C75.3815 23.5004 97.6498 15.4285 117.555 16.227C127.472 16.6248 136.728 19.2206 144.527 24.8246Z'
          stroke='url(#paint0_linear_8486_36125)'
          strokeWidth='4'
        />
        <path
          d='M45.3115 17.293C53.476 13.7176 64.2654 12.6252 78.5713 15.3008C98.594 20.7424 120.459 30.3877 137.279 43.7109C154.13 57.0586 165.675 73.8869 165.675 93.707C165.675 113.954 158.223 137.477 145.15 154.653C132.105 171.794 113.713 182.353 91.6709 177.579C46.3858 167.771 17.9455 133.981 17.9453 93.707C17.9453 72.9905 19.1338 50.6345 27.3418 34.832C31.4069 27.0057 37.1572 20.8639 45.3115 17.293Z'
          stroke={`var(${COLOR.TEXT_ICON_CONSTANT_LIGHT})`}
          strokeOpacity='0.2'
          strokeWidth='4'
        />
        <path
          d='M180.356 86.259C182.677 95.7607 181.731 106.278 175.951 117.751C156.402 149.164 115.702 170.62 76.8646 160.161C57.2791 154.886 36.2705 142.322 22.7003 126.579C9.13411 110.84 3.3129 92.3759 12.8673 74.8242C32.7824 38.2397 67.0585 18.1526 105.816 28.5904C125.548 33.9046 149.045 44.8991 164.58 60.3057C172.332 67.9935 178.02 76.697 180.356 86.259Z'
          stroke={`var(${COLOR.TEXT_ICON_CONSTANT_LIGHT})`}
          strokeOpacity='0.1'
          strokeWidth='4'
        />
        <defs>
          <linearGradient
            id='paint0_linear_8486_36125'
            x1='131.836'
            y1='-10.6328'
            x2='92.008'
            y2='204.124'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor={`var(${COLOR.ACCENT_TERTIARY})`} />
            <stop offset='1' stopColor={`var(${COLOR.ACCENT_TERTIARY})`} />
          </linearGradient>
        </defs>
      </svg>
    </VoiceSearchLoaderProSC>
  )
}
